<template>
  <b-container fluid class="features">
    <b-row class="">
      <b-col>
        <div class="title-container">
          <img
            src="@/assets/rebrand/home/img-feature-title.png"
            alt="shape"
            class="img-feature-title"
          />
        </div>
        <div class="contents accordion" role="tablist">
          <b-row class="">
            <b-col class="feature-item culture-feature">
              <div class="collapsable">
                <div v-b-toggle.collapse-a class="btn-collapse-features">
                  <div class="feature-img">
                    <img
                      src="@/assets/rebrand/home/img-culture.png"
                      alt="culture"
                      class="img-culture"
                    />
                  </div>

                  <h5 class="feature-title title-culture">CULTURE</h5>
                  <b-collapse id="collapse-a" class="mt-2 collapse-features">
                    <p class="feature-desc desc-culture">
                      From Bobbito's first use of the term 'sneakerhead' to the Fresh Prince and
                      Martin in the 90's, sneakers have been moving from a cult following to the
                      mainstream. The new millennium brought online forums and the rise of the
                      reseller, while the following decade allowed new technologies to redefine the
                      secondary markets.
                      <b>SNKRHUD is the next evolution in sneaker collecting.</b>
                    </p>
                  </b-collapse>
                </div>
              </div>
              <div class="non-collapsable">
                <div class="feature-img">
                  <img
                    src="@/assets/rebrand/home/img-culture.png"
                    alt="culture"
                    class="img-culture"
                  />
                </div>
                <div class="feature-text culture-text">
                  <h5 class="feature-title title-culture">CULTURE</h5>
                  <p class="feature-desc desc-culture">
                    From Bobbito's first use of the term 'sneakerhead' to the Fresh Prince and Martin
                    in the 90's, sneakers have been moving from a cult following to the mainstream.
                    The new millennium brought online forums and the rise of the reseller, while the
                    following decade allowed new technologies to redefine the secondary markets.
                    <b>SNKRHUD is the next evolution in sneaker collecting.</b>
                  </p>
                </div>
              </div>
              <div class="divider" />
            </b-col>
            <b-col class="feature-item credibility-feature">
              <div class="collapsable">
                <div v-b-toggle.collapse-b class="btn-collapse-features">
                  <img src="@/assets/mobile/shape-3.png" alt="shape" class="img-shape-3 -mb" />
                  <div class="feature-img">
                    <img
                      src="@/assets/rebrand/home/img-credibility.png"
                      alt="credibility"
                      class="img-credibility"
                    />
                  </div>

                  <h5 class="feature-title title-credibility">CREDIBILITY</h5>
                  <b-collapse id="collapse-b" class="mt-2 collapse-features">
                    <p class="feature-desc desc-credibility">
                      While still in Beta, we've already collaborated with
                      <b>Kicks You Wear, ESPN</b> & <b>Adidas</b>. Our team has combined decades of
                      experience in gaming, music, startups, design, and experiential activations.
                      We've partnered with <b>Dapper Labs</b> to build on <b>Flow</b>,
                      a "blockchain for the mainstream," to create the simplest way to introduce our
                      community to the power of Web3.
                    </p>
                  </b-collapse>
                </div>
              </div>
              <div class="non-collapsable">
                <div class="feature-img">
                  <img
                    src="@/assets/rebrand/home/img-credibility.png"
                    alt="credibility"
                    class="img-credibility"
                  />
                </div>
                <div class="feature-text credibility-text">
                  <h5 class="feature-title title-credibility">CREDIBILITY</h5>
                  <p class="feature-desc desc-credibility">
                    While still in Beta, we've already collaborated with
                    <b>Kicks You Wear, ESPN</b> & <b>Adidas</b>. Our team has combined decades of
                    experience in gaming, music, startups, design, and experiential activations.
                    We've partnered with <b>Dapper Labs</b> to build on <b>Flow</b>,
                    a "blockchain for the mainstream," to create the simplest way to introduce our
                    community to the power of Web3.
                  </p>
                </div>
              </div>
              <div class="divider" />
            </b-col>
            <b-col class="feature-item sneakerverse-feature">
              <div class="collapsable">
                <div v-b-toggle.collapse-c class="btn-collapse-features">
                  <img src="@/assets/mobile/shape-4.png" alt="shape" class="img-shape-4 -mb" />
                  <div class="feature-img">
                    <img
                      src="@/assets/rebrand/home/img-sneakerverse.png"
                      alt="sneakerverse"
                      class="img-sneakerverse"
                    />
                  </div>
                  <h5 class="feature-title title-sneakerverse">SNEAKERV3RSE</h5>
                  <b-collapse id="collapse-c" class="mt-2 collapse-features">
                    <p class="feature-desc desc-sneakerverse">
                      Our community is at our core. We believe Web3 technologies have the ability to
                      <b>unlock wealth generation</b> that has typically been out-of-reach for the
                      communities from which Sneaker Culture emanates. From Side Kicks to DED Stock,
                      our NFT's are designed to create a new kind of hustle, without having to let
                      go of your prized pairs. While our Play-to-Earn Battles introduce a novel way
                      to flex your kicks, you also earn our in-game token, SNKRCred, the more you
                      play, win or lose. This currency unlocks more opportunities on and off
                      platform. This is only the beginning of our future Sneakerv3rse.
                    </p>
                  </b-collapse>
                </div>
              </div>
              <div class="non-collapsable">
                <div class="feature-img">
                  <img
                    src="@/assets/rebrand/home/img-sneakerverse.png"
                    alt="sneakerverse"
                    class="img-sneakerverse"
                  />
                </div>
                <div class="feature-text sneakerverse-text">
                  <h5 class="feature-title title-sneakerverse">SNEAKERV3RSE</h5>
                  <p class="feature-desc desc-sneakerverse">
                    Our community is at our core. We believe Web3 technologies have the ability to
                    <b>unlock wealth generation</b> that has typically been out-of-reach for the
                    communities from which Sneaker Culture emanates. From Side Kicks to DED Stock,
                    our NFT's are designed to create a new kind of hustle, without having to let go
                    of your prized pairs. While our Play-to-Earn Battles introduce a novel way to
                    flex your kicks, you also earn our in-game token, SNKRCred, the more you play,
                    win or lose. This currency unlocks more opportunities on and off platform. This
                    is only the beginning of our future Sneakerv3rse.
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <img
        src="@/assets/rebrand/home/feature-bg.png"
        alt="header banner"
        class="img-feature-bg -wb"
      />
      <img
        src="@/assets/rebrand/home/feature-grid.png"
        alt="header banner"
        class="img-feature-bg -wb"
      />
      <img src="@/assets/mobile/feature-grid.png" alt="header banner" class="img-feature-bg -mb" />
      <img src="@/assets/mobile/shape-1.png" alt="shape" class="img-shape-1 -mb" />
      <img src="@/assets/mobile/shape-2.png" alt="shape" class="img-shape-2 -mb" />

      <img src="@/assets/mobile/shape-5.png" alt="shape" class="img-shape-5 -mb" />
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: 'Features',
};
</script>
